import { ArrowDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { IMAGES, TICKER } from "../../lib/ablemp-data";

export const Hero = () => {
  const navigate = useNavigate();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="manifesto"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full bg-[#0A0F14] text-white overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.heroPayments}
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F14] via-[#0A0F14]/70 to-[#0A0F14]" />
        <div className="absolute inset-0 bg-grain-dark mix-blend-overlay opacity-60" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 pt-32 md:pt-40 pb-16">
        {/* Top meta line */}
        <div
          data-testid="hero-meta"
          className="flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-white/60 reveal"
        >
          <span className="flag-rule" aria-hidden />
          <span>Manifesto Institucional · Brasil · 2025</span>
        </div>

        {/* Main headline — asymmetric editorial */}
        <div className="grid grid-cols-12 gap-6 mt-10 md:mt-14">
          <h1
            data-testid="hero-headline"
            className="col-span-12 lg:col-span-11 font-serif-display text-[44px] leading-[0.95] sm:text-[64px] md:text-[88px] lg:text-[104px] tracking-[-0.02em] reveal reveal-d1"
          >
            Todo Brasileiro tem o direito de{" "}
            <span className="italic font-light text-[#FEDF00]">
              escolher
            </span>{" "}
            como pagar.
          </h1>
        </div>

        {/* Subhead split */}
        <div className="mt-10 md:mt-14 grid grid-cols-12 gap-6 lg:gap-10">
          <div className="col-span-12 lg:col-span-5 reveal reveal-d2">
            <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-md">
              A ABLEMP defende que nenhum meio de pagamento — dinheiro, Pix,
              cartão ou novas tecnologias — possa ser recusado, excluído ou
              imposto. Liberdade de pagar é liberdade de viver.
            </p>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex flex-col gap-6 reveal reveal-d3">
            <div className="flex flex-wrap items-center gap-3">
              <button
                data-testid="hero-cta-primary"
                onClick={() => navigate("/cadastro")}
                className="group inline-flex items-center gap-3 bg-[#FEDF00] text-[#0A0F14] px-7 py-4 text-[12px] uppercase tracking-[0.22em] font-bold hover:bg-white transition-colors duration-300"
              >
                Apoie a causa
                <span className="h-px w-6 bg-[#0A0F14] group-hover:w-10 transition-all" />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => scrollTo("causas")}
                className="group inline-flex items-center gap-3 border border-white/30 text-white px-7 py-4 text-[12px] uppercase tracking-[0.22em] font-medium hover:border-[#FEDF00] hover:text-[#FEDF00] transition-colors"
              >
                Leia o manifesto
              </button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-6 border-t border-white/10 max-w-md">
              <Stat n="100%" label="Direito do consumidor" testid="stat-1" />
              <Stat n="01" label="Causa coletiva" testid="stat-2" />
              <Stat n="∞" label="Meios respeitados" testid="stat-3" />
            </div>
          </div>
        </div>

        {/* Scroll cue */}
        <button
          data-testid="hero-scroll-cue"
          onClick={() => scrollTo("sobre")}
          className="absolute bottom-8 left-6 md:left-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/60 hover:text-white transition-colors"
          aria-label="Continuar leitura"
        >
          <ArrowDown size={14} className="animate-bounce" />
          Continuar
        </button>
      </div>

      {/* Ticker bar */}
      <div className="relative border-t border-white/10 bg-black/40">
        <div className="overflow-hidden">
          <div className="flex whitespace-nowrap animate-marquee py-4">
            {[...TICKER, ...TICKER, ...TICKER].map((t, i) => (
              <span
                key={`${t}-${i}`}
                className="flex items-center gap-6 px-6 text-[11px] uppercase tracking-[0.3em] text-white/55"
              >
                {t}
                <span className="h-1 w-1 rounded-full bg-[#FEDF00]" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ n, label, testid }) => (
  <div data-testid={testid}>
    <div className="font-serif-display text-2xl md:text-3xl text-[#FEDF00]">
      {n}
    </div>
    <div className="text-[10px] uppercase tracking-[0.22em] text-white/55 mt-1">
      {label}
    </div>
  </div>
);

export default Hero;
